module.exports = {"helmetTitle":"Veloe - Bloquear / Substituir VeloeTag","title":"Bloquear / Substituir VeloeTag","text":"Fazendo o bloqueio, você não vai mais ter acesso livre aos locais conveniados.","optionsSubtitle":"Conte para a gente o motivo do bloqueio / substituição:"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/BlockIdentifierNew/data.json
// module id = 1810
// module chunks = 0